module.exports = __webpack_public_path__ + "static/media/devOps-icon.a153a450.svg";